"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactionEntriesListResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
class ReactionEntriesListResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'reaction',
            'compliedDate',
            'studentFirstName',
            'studentLastName',
            'studentName',
            'studentId',
            'studentExtId',
            'studentGrade',
            'behaviorEntryDate',
            'behaviorEntryTime',
            'behaviorCodeName',
            'reactionName',
            'reactionDate',
            'behaviorCodeEntryId',
            'behaviorCodeReactionId',
            'scheduledReactionId',
            'behaviorCodeId',
            'behaviorCodePassMessage',
            'issuedBy',
            'schoolName',
            'behaviorReactionDate',
            'behaviorReactionName',
            'behaviorEntries',
            'reactionPoints',
            'studentTotalPoints',
            'period',
            'printCopies',
            'printPass'
        ];
    }
    id;
    reaction;
    compliedDate;
    studentName;
    studentFirstName;
    studentLastName;
    studentId;
    studentExtId;
    studentGrade;
    behaviorEntryDate;
    behaviorEntryTime;
    behaviorCodeName;
    behaviorCodeId;
    reactionName;
    reactionDate;
    scheduledReactionId;
    behaviorCodeReactionId;
    behaviorCodeEntryId;
    issuedBy;
    schoolName;
    behaviorReactionDate;
    behaviorReactionName;
    behaviorEntries;
    reactionPoints;
    studentTotalPoints;
    period;
    profilePhotoUrl;
    printCopies;
    printPass;
    behaviorCodePassMessage;
    reactionPassMessage;
    homeroom;
}
exports.ReactionEntriesListResponseDto = ReactionEntriesListResponseDto;
